<template>
    <div>
        <a href="javascript:"
           :class="{active: activePage === 'customerInfo' }"
           @click="$emit('setCustomerPage', 'customerInfo')"
        >
            <i class="fal fa-pencil"></i> Bedrijf gegevens
        </a>
        <a href="javascript:"
           :class="{active: activePage === 'customerCandidatePlacing' }"
           @click="$emit('setCustomerPage', 'customerCandidatePlacing')"
        >
            <i class="fal fa-user"></i> Kandidaat plaatsen
        </a>
        <a href="javascript:"
           :class="{active: activePage === 'customerPlacingHistory' }"
           @click="$emit('setCustomerPage', 'customerPlacingHistory')"
        >
            <i class="far fa-folder-open"></i> Plaatsingen
        </a>
        <a href="javascript:"
           :class="{active: activePage === 'customerDocuments' }"
           @click="$emit('setCustomerPage', 'customerDocuments')"
        >
            <i class="fal fa-file"></i> Bestanden
        </a>
      <a href="javascript:"
         :class="{active: activePage === 'customerPoolOverview' }"
         @click="$emit('setCustomerPage', 'customerPoolOverview')"
      >
        <i class="fal fa-user-clock"></i> Poule
      </a>
      <a href="javascript:"
         :class="{active: activePage === 'customerAppointments' }"
         @click="$emit('setCustomerPage', 'customerAppointments')"
      >
        <i class="fal fa-calendar-alt"></i> Afspraken
      </a>
        <a href="javascript:"
           :class="{active: activePage === 'customerStatistics' }"
           @click="$emit('setCustomerPage', 'customerStatistics')"
        >
            <i class="fal fa-flask"></i> Statistieken
        </a>
      <a
        href="javascript:"
        v-if="Can(rights.CUSTOMER_EDIT)"
        :class="{active: activePage === 'customerOvertimeSettings' }"
        @click="$emit('setCustomerPage', 'customerOvertimeSettings')"
      >
        <i class="fal fa-clock"></i> Overwerk instellingen
      </a>
      <a
        href="javascript:"
        :class="{active: activePage === 'customerVisits' }"
        @click="$emit('setCustomerPage', 'customerVisits')"
      >
        <i class="fal fa-handshake"></i> Bezoeken
      </a>
      <a
        href="javascript:"
        v-if="mayViewAppOnboarding()"
        :class="{active: activePage === 'customerAppOnboarding' }"
        @click="$emit('setCustomerPage', 'customerAppOnboarding')"
      >
        <i class="fal fa-mobile"></i> App onboarding
      </a>
      <div v-if="customer && Can(rights.IS_ADMIN)" class="actief-klant-checkbox" :class="{'active': customer.activeCustomer !== false}">
        <i class="fal fa-building"></i> Actieve klant
        <div class="custom-control custom-checkbox">
          <input
              type="checkbox"
              id="activeCustomer"
              class="custom-control-input"
              :checked="customer.activeCustomer !== false"
              :disabled="!Can(rights.IS_ADMIN)"
              @change="toggleActiveCustomer"
          />
          <label class="custom-control-label" for="activeCustomer"></label>
        </div>
      </div>
    </div>
</template>
<script>
    import { Can } from '../../../permission/ability';
    import { RIGHTS } from '../../views/roles/rights';
    import { mayViewAppOnboarding } from '@/utils/appOnboardingAccess';
    import store from '@/store';

    export default {
        props: {
            activePage: String,
            customer: Object,
        },
        data: () => ({
            rights: RIGHTS
        }),
        methods: {
            Can,
            mayViewAppOnboarding,
            async toggleActiveCustomer() {
                const isCurrentlyActive = this.customer.activeCustomer !== false;
                const newActiveValue = !isCurrentlyActive;
                const patch = { id: this.customer.id, activeCustomer: newActiveValue };
                if (!newActiveValue) {
                    patch.purchasingFactor = 0;
                    patch.saleFactor = 0;
                    this.customer.purchasingFactor = 0;
                    this.customer.saleFactor = 0;
                }
                this.$set(this.customer, 'activeCustomer', newActiveValue);
                store.commit('setLoading', true);
                await store.dispatch('customers/patch', patch);
                store.commit('setLoading', false);
                this.$toasted.global.successRequest({
                    message: newActiveValue ? 'Klant geactiveerd' : 'Klant gedeactiveerd'
                });
            }
        }
    }
</script>

<style lang="scss" scoped>
.actief-klant-checkbox {
  position: relative;
  display: block;
  font-size: 14px;
  padding: 0.5rem 0;
  line-height: 34px;
  color: #8d97ad;

  &.active {
    color: #25b7bc;
  }

  i {
    width: 24px;
    text-align: center;
    display: inline-block;
  }

  .custom-control {
    position: absolute;
    right: 0;
    top: 15%;
    transform: translateY(-50%);
  }
}
</style>
